<template>
    <v-card class="study fill-height">
        <v-card-title primary-title>
            <v-icon @click="back" class="icon-back">
                keyboard_arrow_left
            </v-icon>
            <div>
                <div class="headline">{{ selectedStudy.name }}</div>
                <div v-if="selectedStudy.start_at"><b>Début :</b> {{ selectedStudy.start_at | shortDate }}</div>
                <div v-if="selectedStudy.end_at"><b>Fin :</b> {{ selectedStudy.end_at | shortDate }}</div>
                <div><b>Status :</b> {{ selectedStudy.status }}</div>
            </div>
            <!--<v-spacer></v-spacer>-->
            <v-spacer></v-spacer>

            <template v-if="hasTreatment">
                <v-btn v-if="$route.name === 'study.view'" flat @click="editStudy()">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn v-if="$route.name === 'study.view'" flat @click="deleteDialog = true">
                    <v-icon>delete</v-icon>
                </v-btn>
            </template>
            <td class="text-xs-right">
                <v-switch
                    v-model="blockNewPatient"
                    label="Bloquer l'inclusion des nouveaux patients"
                />
                <v-btn right color="primary" @click="exportStudy">
                    Export
                </v-btn>
            </td>
        </v-card-title>

        <v-divider></v-divider>

        <router-view></router-view>

        <v-dialog v-model="deleteDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Supprimer l'étude</v-card-title>
                <v-card-text>Voulez-vous vraiment supprimer l'étude ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="deleteStudy()">Oui, supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {getTranslationString} from "../../helper";

export default {
    name: "UserView",
    components: {},
    computed: {
        ...mapState(
            'studies',
            {
                selectedStudy: state => state.selectedStudy,
            }
        ),
        hasTreatment() {
            return !this.selectedStudy.treatments.length
        },
        blockNewPatient: {
            get() {
                return this.selectedStudy.block_new_patient
            },
            set(value) {
                this.toggleBlockNewPatient(value)
            }
        }
    },
    data() {
        return {
            deleteDialog: false,
        }
    },
    created() {
        this.setSelectedStudyId(this.$route.params.id)
        this.getStudyInfo()
    },
    methods: {
        back() {
            this.$router.back()
        },
        ...mapActions('studies', [
            'getStudyInfo',
            'postDeleteStudy',
            'getStudyExport',
            'toggleBlockNewPatient'
        ]),
        ...mapMutations('studies', [
            'setSelectedStudyId'
        ]),
        getText(key) {
            return getTranslationString(key)
        },
        editStudy(locked) {
            this.dialog = false;
            this.$router.push({
                name: 'study.edit'
            })
        },

        deleteStudy() {
            this.deleteDialog = false;
            this.postDeleteStudy(this.selectedStudy).then(response => {
                    this.$router.replace({name: 'studies'})
                }
            ).catch(reason => {
            })
        },
        exportStudy() {
            this.getStudyExport(this.selectedStudy.id).then(response => {
                let fileName = response.headers["content-disposition"].split("filename=")[1];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                        fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                    document.body.appendChild(link);
                    link.click();
                }
            }).catch(reason => {
                //Stay here..
            })
        }
    }
}
</script>

